<template>
  <div
    class="check-detail-comp"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    element-loading-text="Loading"
  >
    <div class="detail-title">
      <title-comp :title="$t('检测信息详情')"></title-comp>
      <div style="font-size: 16px; font-weight: bold">
        <span>{{ checkTime }}</span>
      </div>
    </div>
    <el-row>
      <scrollbar type="none">
        <div class="content-box" slot="scrollbar">
          <div class="detail-content" v-for="(m, i) in materials" :key="i">
            <el-form :inline="true" size="mini" v-if="m.moreInfos">
              <el-form-item v-for="(v, index) in m.moreInfos" :key="index" :label="`${v.name}: `">
                <p>{{ v.content }}</p>
              </el-form-item>
            </el-form>
            <div v-else>
              <label style="margin-right: 5px">{{ $t('检测结果') }}:</label>
              <span>{{ m.materialName }}</span>
            </div>
          </div>
          <el-divider></el-divider>
          <div>
            <div v-if="rawDatas.length === 0" style="margin-top: 10px">
              {{ $t('暂无光谱') }}
            </div>
            <div class="echart-parent" v-else>
              <v-chart
                v-for="(v, i) in rawDatas"
                style="height: 300px"
                :key="i"
                :options="
                  materialOption({
                    title: { text: v.name },
                    xAxis: { data: v.xAxis },
                    series: [{ data: v.yAxis }]
                  })
                "
                :autoresize="true"
              ></v-chart>
            </div>
          </div>
        </div>
      </scrollbar>
    </el-row>
  </div>
</template>

<script>
import { formatTimestamp } from '@/utils/utils';
import { getHisDetectDetail } from '@/api/query';
import { materialOption } from '@/echartOption/material';

export default {
  name: 'CheckDetail',
  props: {
    info: Object
  },
  data() {
    return {
      checkTime: '',
      materials: [],
      rawDatas: [],
      loading: true
    };
  },
  methods: {
    langChangeHandler() {
      this.renderPage();
    },
    materialOption,
    renderPage() {
      try {
        const { deviceType, id } = this.info;
        this.loading = true;
        getHisDetectDetail({
          testId: id,
          deviceType: deviceType
        })
          .then(res => {
            const { beginTime, materials, rawXYDatas } = res.data;
            this.checkTime = formatTimestamp(beginTime);
            this.materials = materials;
            this.rawDatas = rawXYDatas;
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.renderPage();
  },
  watch: {
    info() {
      this.renderPage();
    }
  }
};
</script>

<style lang="scss">
.check-detail-comp {
  height: 100%;
  padding: 15px;
  @include border-style;
  > .el-row {
    height: calc(100% - 70px);
    .el-col {
      height: 100%;
    }
  }
  .detail-title {
    display: flex;
    justify-content: space-between;
  }
  .content-box {
    height: 100%;
    .detail-content {
      padding-left: 15px;
      font-size: 16px;
      p {
        white-space: pre-line;
      }
    }
  }
  .echart-parent {
    overflow: hidden;
  }
}
</style>
